import { render, staticRenderFns } from "./ByImportacionComponent.vue?vue&type=template&id=1dabe6e0"
import script from "./ByImportacionComponent.vue?vue&type=script&lang=ts"
export * from "./ByImportacionComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports